/**
 * Templated copy rendered at the bottom of every Toile pack landing page — Toile's port of
 * narcis's/ovid's own `packs/aboutNarcis.ts`/`aboutOvid.ts`. Canon renders this section
 * unconditionally, on every pack regardless of state, so it carries no absence case the way the
 * SEO backbone's optional `styleGuide`/`prepTips`/`useCases` sections do.
 *
 * One source of truth — do NOT edit per-pack.
 */
export const ABOUT_TOILE = {
    title: 'About toile',
    paragraph:
        'This page is a showcase and a starting point: nine samples already rendered, three readings of the ' +
        'pack crossed with three styles, each shown at the size and ratio it was made for. Take any of them ' +
        'further on the wall with a few words, or ask for all nine again under your own direction; a sign-in ' +
        'keeps what you make, and it is free while Toile is new. The recipe behind each sample — the ' +
        'subject, the style, the palette, the framing — travels with the image rather than staying private ' +
        'to the render: it is in the alt text of every sample and in the page\'s own structured data, so a ' +
        'search engine reads the same handles a person would.',
} as const
